const hasReverseAndClockwise = (shape) => 'reverse' in shape && 'clockwise' in shape;
const needsReversal = (shape) => {
    if (shape.children.length === 1) {
        const child = shape.children[0];
        return !(child && hasReverseAndClockwise(child) && child.clockwise);
    }

    const outerShape = shape.children.find((child) => !isContainedByOthers(shape, child));
    return !outerShape?.clockwise;
};

// Check if shape is contained within others
const isContainedByOthers = (parent, target) => {
    for (const shape of parent.children) {
        if (shape === target) continue;

        let containsAll = true;
        const points = 'segments' in target ? target.segments : [];

        for (const segment of points) {
            if (!shape.contains(segment.point)) {
                containsAll = false;
                break;
            }
        }

        if (containsAll) return true;
    }
    return false;
};

const reverseShapes = (shape) => {
    if (!shape.children) return;
    if (needsReversal(shape))
        for (const child of shape.children) {
            if (hasReverseAndClockwise(child)) {
                child.reverse?.();
            }
        }
};

export { reverseShapes };
